import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IApplicationProcess {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  pre_title?: string;
  pre_title_color?: string;
  title?: string;
  title_start_color?: string;
  title_end_color?: string;
  title_highlight_color?: string;
  title_gradient_direction?: string;
  subtitle_1?: string;
  subtitle_1_color?: string;
  subtitle_1_background_color?: string;
  subtitle_2?: string;
  subtitle_2_color?: string;
  subtitle_2_background_color?: string;
  background_image?: string;
  alt_background_image?: string;
  box_start_color?: string;
  box_end_color?: string;
  gradient_direction?: string;
  cta_label?: string;
  accent_color?: string;
  cta_link?: string;
  cta_is_cta?: boolean;
  variant?: string;
  metadata_1?: any[];
  metadata_2?: any[];
  status?: boolean;
}

export async function createApplicationProcess(payload: Partial<IApplicationProcess>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.APPLICATION_PROCESS.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateApplicationProcess(id: number, payload: Partial<IApplicationProcess>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.APPLICATION_PROCESS.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
